// components/CopyButton.jsx
import { useCopyWithToast } from "hooks/useCopyWithToast";

export const CopyButton = ({ 
  text, 
  size = 'sm', 
  variant = 'outline-primary',
  successVariant = 'success',
  className = '',
  title = 'Copy to clipboard',
  successTitle = 'Copied!',
  onCopy, // Optional callback for when copy is successful
  toastCallback // Optional toast callback
}) => {
  const { copyWithToast, isCopying, isCopied } = useCopyWithToast();

  const handleClick = async () => {
    if (text) {
      const success = await copyWithToast(text, toastCallback);
      if (success && onCopy) {
        onCopy(text);
      }
    }
  };

  const isSuccess = isCopied && !isCopying;

  return (
    <button
      type="button"
      className={`btn btn-${size} ${isSuccess ? `btn-${successVariant}` : `btn-${variant}`} ${className}`}
      onClick={handleClick}
      title={isSuccess ? successTitle : title}
      disabled={!text || isCopying}
    >
      {isSuccess ? (
        <i className="fas fa-check"></i>
      ) : (
        <i className="fas fa-copy"></i>
      )}
    </button>
  );
};